import { useState } from "react";
import { inputReadonlyDesign, inputDefaultDesign } from "../inputClass";

export function Profile() {
    const [userInfo, setUserInfo] = useState({
        name: "홍길동",
        birth: "1999.01.12",
        gender: "남",
        email: "test@gmail.com",
        phone: "01012345678",
        address: {
            country: "대한민국",
            region: "서울 성북구",
            detail: "동소문로 34길"
        },
        emergencyContact: "0101111222222"
    });
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name.startsWith("address.")) {
            const key = name.split(".")[1];
            setUserInfo((prev) => ({
                ...prev,
                address: {
                    ...prev.address,
                    [key]: value
                }
            }));
        } else {
            setUserInfo((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };
    
    return (
        <section className={`flex-col px-6 py-5 gap-4 w-[80%]`}>
           
            
            <h1 className={`text-2xl`}>프로필 관리</h1>
            
            <div className={`flex items-end`}>
                <div className={`w-[150px] h-[150px] rounded-full border overflow-hidden relative`}>
                    <img
                        src="/images/profile.svg"
                        alt="프로필 이미지"
                        className="w-[70%] h-auto object-cover absolute bottom-0 left-1/2 -translate-x-1/2"
                    />
                </div>
                <ul className={`pb-2 pl-4 text-sm`}>
                    <li className={`list-disc`}>10MB 미만의 JPG, GIF, PNG 업로드 가능</li>
                    <li className={`list-disc`}>본인 확인, 자격증에 사용</li>
                </ul>
            </div>
            <div>
                <h1 className={`mb-1 font-bold`}>이메일</h1>
                <input
                    type="email"
                    className={inputReadonlyDesign}
                    name="email"
                    value={userInfo.email}
                    onChange={handleChange}
                />
            </div>
            
            <div>
                <h1 className={`mb-1 font-bold`}>비밀번호</h1>
                <button className={`py-4 text-center text-xl border-2 rounded-lg w-full`}>비밀번호 재설정</button>
            </div>
            
            <div>
                <h1 className={`mb-1 font-bold`}>이름</h1>
                <input
                    type="text"
                    className={inputReadonlyDesign}
                    name="name"
                    value={userInfo.name}
                    onChange={handleChange}
                />
            </div>
            
            <div>
                <h1 className={`mb-1 font-bold`}>생년월일</h1>
                <input
                    type="text"
                    className={inputDefaultDesign}
                    name="birth"
                    value={userInfo.birth}
                    onChange={handleChange}
                />
            </div>
            <div>
                <h1 className="mb-1 font-bold">성별</h1>
                <div className="flex gap-4">
                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="gender"
                            value="남"
                            checked={userInfo.gender === "남"}
                            onChange={handleChange}
                        />
                        남
                    </label>
                    <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="gender"
                            value="여"
                            checked={userInfo.gender === "여"}
                            onChange={handleChange}
                        />
                        여
                    </label>
                </div>
            </div>
            
            
            <div>
                <h1 className={`mb-1 font-bold`}>전화번호</h1>
                <div className={`relative`}>
                    <input
                        type="text"
                        className={inputDefaultDesign}
                        name="phone"
                        value={userInfo.phone}
                        onChange={handleChange}
                    />
                    <button
                        className={`py-1 px-8 text-center border-2 absolute top-1/2 right-[10px] -translate-y-1/2 `}>변경하기
                    </button>
                </div>
            </div>
            
            <div className={`flex flex-col gap-4`}>
                <h1 className={`mb-1 font-bold`}>주소</h1>
                <input
                    type="text"
                    className={inputDefaultDesign}
                    name="address.country"
                    value={userInfo.address.country}
                    onChange={handleChange}
                />
                <div className={`relative`}>
                    <input
                        type="text"
                        className={`${inputDefaultDesign} `}
                        name="address.region"
                        value={userInfo.address.region}
                        onChange={handleChange}
                    />
                    <button
                        className={`py-1 px-8 text-center border-2 absolute top-1/2 right-[10px] -translate-y-1/2 `}>검색하기
                    </button>
                </div>
                <input
                    type="text"
                    className={inputDefaultDesign}
                    name="address.detail"
                    value={userInfo.address.detail}
                    onChange={handleChange}
                />
            </div>
            
            
            <div>
                <h1 className={`mb-1 font-bold`}>긴급 연락처</h1>
                <input
                    type="text"
                    className={inputDefaultDesign}
                    name="emergencyContact"
                    value={userInfo.emergencyContact}
                    onChange={handleChange}
                />
            </div>
            <button className={`py-4 text-center bg-black text-white`}>저장</button>
        </section>
    );
}
